module.exports = __webpack_public_path__ + "img/20200507_140925.933368ad.jpg";